import React from "react";
import * as c from "./pricingPlanBgs.module.scss";
import classNames from "classnames";

const EssentialsBackground = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="755"
    height="848"
    viewBox="0 0 755 848"
    fill="none"
    className={classNames(c.blur, c.essentials)}
  >
    <g opacity="0.5" filter="url(#filter0_f_5898_6913)">
      <path
        d="M46.184 585.715C86.05 703.964 233.965 627.481 320.441 561.301C406.918 495.122 554.407 736.844 554.884 530.888C555.105 435.305 528.418 381.847 482.7 316.779C374.099 162.209 217.057 185.598 130.58 251.777C44.1034 317.957 6.31797 467.466 46.184 585.715Z"
        fill="#E9DBFC"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_5898_6913"
        x="-169.695"
        y="0.746582"
        width="924.581"
        height="846.665"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_5898_6913" />
      </filter>
    </defs>
  </svg>
);

const StandardBackground = () => (
  <svg
    width="925"
    height="789"
    viewBox="0 0 925 789"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames(c.blur, c.standard)}
  >
    <g filter="url(#filter0_f_5898_6911)">
      <ellipse cx="262.5" cy="194.5" rx="262.5" ry="194.5" transform="matrix(1 0 0 -1 200 589.001)" fill="#FDDFEE" />
    </g>
    <defs>
      <filter
        id="filter0_f_5898_6911"
        x="0"
        y="0.000976562"
        width="925"
        height="789"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_5898_6911" />
      </filter>
    </defs>
  </svg>
);

const UnlimitedBackground = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="678"
    height="816"
    viewBox="0 0 678 816"
    fill="none"
    className={classNames(c.blur, c.unlimited)}
  >
    <g filter="url(#filter0_f_5898_6912)">
      <path
        d="M383.279 237.229C352.374 212.427 302.105 195.228 260.428 202.5C127.711 225.655 241.832 528.754 357.116 579.304C455.225 622.323 651.952 649.924 662.922 525.556C669.879 446.687 648.484 365.646 584.512 342.247C546.543 328.359 483.177 346.206 449.791 323.649C423.675 306.003 407.937 257.019 383.279 237.229Z"
        fill="#FFEBDD"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_5898_6912"
        x="0.798096"
        y="0.818848"
        width="863.379"
        height="814.773"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="50" result="effect1_foregroundBlur_5898_6912" />
      </filter>
    </defs>
  </svg>
);

export { UnlimitedBackground, EssentialsBackground, StandardBackground };
